
// see https://en.wikipedia.org/wiki/Jenkins_hash_function#one_at_a_time
function hash (b) {
  let a = 0
  for (let c = b.length; c--;) {
    a += b.charCodeAt(c)
    a += a << 10
    a ^= a >> 6
  }
  a += a << 3
  a ^= a >> 11
  return ((a + (a << 15) & 4294967295) >>> 0).toString(16)
}

const initialState = {
  messages: [],
  flashs: []
}

const mutations = {
  /**
   * @deprecated use addMessage instead
   * adds an error to the storage
   */
  addError (state, error) {
    // just a string given as error
    if (typeof error === 'string') {
      error = {
        message: error
      }
    }

    // add an unique id for identification on removal
    if (typeof error.__uuid === 'undefined') {
      error.__uuid = hash(error.message)
    }

    // add type danger
    if (typeof error.type === 'undefined') {
      error.type = 'danger'
    }

    state.messages.push(error)
  },

  addMessage (state, message) {
    // add an unique id for identification on removal
    if (typeof message.__uuid === 'undefined') {
      message.__uuid = hash(message.message)
    }
    state.messages.push(message)
  },

  /**
   * @deprecated use addFlashMessage with message.type = danger
   */
  addFlash (state, message) {
    if (typeof message === 'string') {
      message = {
        message: message
      }
    }

    // add type danger
    if (typeof message.type === 'undefined') {
      message.type = 'danger'
    }

    // add an unique id for identification on removal
    if (typeof message.__uuid === 'undefined') {
      message.__uuid = hash(message.message)
    }

    state.flashs.push(message)
  },
  addFlashMessage (state, message) {
    // add an unique id for identification on removal
    if (typeof message.__uuid === 'undefined') {
      message.__uuid = hash(message.message)
    }
    state.flashs.push(message)
  },

  /**
   * gets a list of errors and removes them from the storage
   */
  clearErrors (state) {
    state.messages = state.messages.filter((message) => {
      return message.type !== 'danger'
    })
  },
  clearSuccesses (state) {
    state.messages = state.messages.filter((message) => {
      return message.type !== 'success'
    })
  },
  clearWarnings (state) {
    state.messages = state.messages.filter((message) => {
      return message.type !== 'warning'
    })
  },

  clearMessages (state) {
    state.messages = []
  },

  /**
   * @deprecated use removeMessage
   * removes a single error from the list
   */
  removeError (state, error) {
    if (error.persistent === true) {
      return
    }
    const index = state.messages.findIndex(cmp => {
      return cmp.__uuid === error.__uuid
    })
    if (index === -1) {
      return
    }
    state.messages.splice(index, 1)
  },
  removeMessage (state, message) {
    if (message.persistent === true) {
      return
    }
    const index = state.messages.findIndex(cmp => {
      return cmp.__uuid === message.__uuid
    })
    if (index === -1) {
      return
    }
    state.messages.splice(index, 1)
  },
  activateFlashs (state) {
    if (state.flashs.length > 0) {
      state.messages = state.messages.concat(state.flashs)
      state.flashs = []
    }
  }
}

const getters = {
  /**
   * @deprecated use peekMessages instead
   * gets a list of errors without removing them in storage
   */
  peekErrors (state) {
    return state.messages.filter((message) => {
      return message.type === 'danger'
    })
  },
  peekMessages (state) {
    return state.messages.slice()
  },
  /**
   * @deprecated use hasMessages instead
   */
  hasErrors (state) {
    return state.messages.filter((message) => {
      return message.type === 'danger'
    }).length > 0
  },
  hasMessages (state) {
    return state.messages.length > 0
  },
  /**
   * @deprecated use countMessages instead
   */
  countErrors (state) {
    return state.messages.filter((message) => {
      return message.type === 'danger'
    }).length
  },
  countMessages (state) {
    return state.messages.length
  }
}

const ErrorModule = {
  state: initialState,
  mutations,
  getters
}

export {
  mutations,
  getters,
  ErrorModule
}
